import {useFormDataSelector, useFormSelector} from "mrf/redux/ReduxHelper";
import React from "react";
import FormCRUD from "mrf/view/FormCRUD";
import {Col, Grid} from "mrf/view/Grid";
import {ImageAddIcon} from 'styles/components/Icons';
import HandleDownload from "mrf/utils/HandleDownload";
import Button from "mrf/view/Button";
import UploadField from "mrf/view/UploadField";

export default function TranslationLanguageForm({history, match}) {
    const context = useFormSelector({
        id: match?.params?.id,
        resource: 'translationLanguages',
        endpoint: `/api/translationLanguages/${match?.params?.id}`,
        keys: []
    });
    
    const data = useFormDataSelector(context);
    
    return (
        <FormCRUD
            title='Translation Language'
            match={match}
            history={history}
            context={context}
            hideDelete={true}
            disableAutoValidate={true}
            endpoint='/api/translationLanguages/updateTranslationFile'
            skipGetAfterEdit
        >
            <Grid gap={3}>
                <Col size={4}>
                    <UploadField
                        required
                        label='Translation File'
                        field='translationFile'
                        accept='.json'
                        placeholder='Upload Translation File'
                        icon={ImageAddIcon}
                    />
                  
                </Col>
                <Col size={4} align={'end'} className={'h-4/6'}>
                        <Button color='primary' tooltip='Download Original Translation File' className={'h-full'}
                                onClick={async () => await HandleDownload(`/api/translationLanguages/getStockTranslationFile/${data.code}`)}>
                            Download Original Translation File
                        </Button>
                </Col>
                <Col size={4} align={'end'} className={'h-4/6'}>
                    <Button color='primary' tooltip='Download Current Translation File' className={'h-full'}
                            onClick={async () => await HandleDownload(`/api/translationLanguages/getTranslationFile/${data.code}`)}>
                        Download Current Translation File
                    </Button>
                </Col>
            </Grid>
        </FormCRUD>
    );
}